interface Nav {
  icon: string,
  red_icon: string,
  children: Array<NavChildren>
}
interface NavChildren {
  name: string,
  path: string
}
const RouterList: Array<Nav & NavChildren> = [
  {
    icon: require('./assets/img/menu/menu-icon1.png'),
    red_icon: require('./assets/img/menu/red-menu-icon1.png'),
    name: '数据统计',
    path: '/order',
    children: [
      {
        name: '数据统计',
        path: '/order/dataStatistics'
      },
    ]
  },
  {
    icon: require('./assets/img/menu/menu-icon1.png'),
    red_icon: require('./assets/img/menu/red-menu-icon1.png'),
    name: '配件管理',
    path: '/parts',
    children: [
      {
        name: '配件管理',
        path: '/parts/management'
      },
      {
        name: '配件分类',
        path: '/parts/classification'
      },
      {
        name: '配件品牌',
        path: '/parts/brand'
      },
      {
        name: '配件单位',
        path: '/parts/company'
      }
    ]
  },
  {
    icon: require('./assets/img/menu/menu-icon2.png'),
    red_icon: require('./assets/img/menu/red-menu-icon2.png'),
    name: '订单管理',
    path: '/order',
    children: [
      {
        name: '服务订单',
        path: '/order/service'
      },
      {
        name: '购卡订单',
        path: '/order/card'
      },
    ]
  },
  {
    icon: require('./assets/img/menu/menu-icon2.png'),
    red_icon: require('./assets/img/menu/red-menu-icon2.png'),
    name: '采购管理',
    path: '/purchase',
    children: [
      {
        name: '采购管理',
        path: '/purchase/management'
      },
      {
        name: '采购明细',
        path: '/purchase/detailed'
      },
      {
        name: '供应商',
        path: '/purchase/supplier'
      }
    ]
  },

  {
    icon: require('./assets/img/menu/menu-icon3.png'),
    red_icon: require('./assets/img/menu/red-menu-icon3.png'),
    name: '仓库管理',
    path: '/warehouse',
    children: [
      {
        name: '出库单',
        path: '/warehouse/exceed'
      },
      {
        name: '入库单',
        path: '/warehouse/libraryList'
      },
      {
        name: '采购入库',
        path: '/warehouse/purchaseWarehousing'
      },
      {
        name: '配件库存',
        path: '/warehouse/partsStockList'
      },
      {
        name: '进销存',
        path: '/warehouse/enterPin'
      },
      {
        name: '领料明细',
        path: '/warehouse/pickingInfo'
      }
    ]
  },

  {
    icon: require('./assets/img/menu/menu-icon5.png'),
    red_icon: require('./assets/img/menu/red-menu-icon5.png'),
    name: '运营管理',
    path: '/operate',
    children: [
      {
        name: '服务管理',
        path: '/project/service'
      },
      {
        name: '预约管理',
        path: '/operate/preabout'
      },
      {
        name: '优惠券管理',
        path: '/operate/coupon'
      },
      {
        name: '尊享卡管理',
        path: '/operate/VipCard'
      },
      {
        name: '评论管理',
        path: '/operate/evaluation'
      },
      {
        name: '返现方案',
        path: '/operate/reappearance'
      },
      {
        name: '微信菜单',
        path: '/'
      },
      {
        name: '运营设置',
        path: '/operate/operation'
      },

      {
        name: '预约设置',
        path: '/operate/appointment'
      },
      {
        name: '尊享卡项目',
        path: '/operate/vipClass'
      },
      {
        name: '广告图设置',
        path: '/operate/banner'
      },
      {
        name: '服务分类',
        path: '/operate/projectType'
      }
    ]
  },
  {
    icon: require('./assets/img/menu/menu-icon2.png'),
    red_icon: require('./assets/img/menu/red-menu-icon2.png'),
    name: '会员管理',
    path: '/member',
    children: [
      {
        name: '会员列表',
        path: '/member/memberlist'
      },
      {
        name: '会员权益',
        path: '/member/LevelList'
      },
    ]
  },
  {
    icon: require('./assets/img/menu/menu-icon6.png'),
    red_icon: require('./assets/img/menu/red-menu-icon6.png'),
    name: '前台收银',
    path: '/cashRegister',
    children: [
      {
        name: '接车开单',
        path: '/cashRegister/billing'
      },
      {
        name: '工单结算',
        path: '/cashRegister/worksettlement'
      },
      {
        name: '配件销售',
        path: '/cashRegister/PartsSale'
      },
      {
        name: '营业对账',
        path: '/cashRegister/reconciliationList'
      }
    ]
  },
  {
    icon: require('./assets/img/menu/menu-icon7.png'),
    red_icon: require('./assets/img/menu/red-menu-icon7.png'),
    name: '财务管理',
    path: '/Bookkeeping',
    children: [
      {
        name: '收入记账',
        path: '/Bookkeeping/incomeList'
      },
      {
        name: '支出记账',
        path: '/Bookkeeping/expenditureList'
      },
      {
        name: '固定资产',
        path: '/Bookkeeping/fixedList'
      },
      {
        name: '工单应收',
        path: '/Bookkeeping/workList'
      },
      {
        name: '采购应付',
        path: '/Bookkeeping/purchaseList'
      },
      {
        name: '其他应付',
        path: '/Bookkeeping/otherList'
      },
      {
        name: '支付流水',
        path: '/Bookkeeping/payBills'
      },
      {
        name: '提现审核',
        path: '/Bookkeeping/Withdrawal'
      },
      {
        name: '充值记录',
        path: '/Bookkeeping/rechargeLog'
      },
      {
        name: '每月结算',
        path: '/Bookkeeping/SettlementMonth'
      },
      {
        name: '狼豆余额发放',
        path: '/Bookkeeping/BalanceLog'
      },
    ]
  },
  {
    icon: require('./assets/img/menu/menu-icon8.png'),
    red_icon: require('./assets/img/menu/red-menu-icon8.png'),
    name: '业务报表',
    path: '/BusinessReport',
    children: [
      {
        name: '项目销售明细',
        path: '/BusinessReport/projectSell'
      },
      {
        name: '配件销售明细',
        path: '/BusinessReport/mountingsSell'
      },
      {
        name: '项目施工明细',
        path: '/BusinessReport/projectConstruction'
      },
      {
        name: '配件施工明细',
        path: '/BusinessReport/partsConstruction'
      },
      {
        name: '部门利润汇总',
        path: '/BusinessReport/profitSummary'
      },
      // {
      //   name:'尊享卡销售明细 ',
      //   path:'/'
      // }
    ]
  },
  {
    icon: require('./assets/img/menu/menu-icon9.png'),
    red_icon: require('./assets/img/menu/red-menu-icon9.png'),
    name: '客户服务',
    path: '/customer',
    children: [
      {
        name: '客户回访',
        path: '/customer/returnVisit'
      },
      {
        name: '车辆管理',
        path: '/customer/vehicle'
      },
      {
        name: '到期提醒',
        path: '/customer/expire'
      },
      {
        name: '车辆产值排行',
        path: '/customer/carRank'
      },
    ]
  },
  {
    icon: require('./assets/img/menu/menu-icon10.png'),
    red_icon: require('./assets/img/menu/red-menu-icon10.png'),
    name: '人事管理',
    path: '/personnel',
    children: [
      {
        name: '员工管理',
        path: '/personnel/staff'
      },
      {
        name: '部门管理',
        path: '/personnel/branch'
      },
      {
        name: '职位管理',
        path: '/personnel/position'
      },
      {
        name: '操作日志',
        path: '/personnel/operationLogList'
      }
    ]
  },
  {
    icon: require('./assets/img/menu/menu-icon12.png'),
    red_icon: require('./assets/img/menu/red-menu-icon12.png'),
    name: '门店管理',
    path: '/',
    children: [
      {
        name: '门店管理',
        path: '/framework/management'
      },
      {
        name: '师傅展示',
        path: '/framework/mechanic'
      },
      {
        name: '菜单管理',
        path: '/framework/menu'
      }
    ]
  },
  {
    icon: require('./assets/img/menu/menu-icon12.png'),
    red_icon: require('./assets/img/menu/red-menu-icon12.png'),
    name: '基本设置',
    path: '/',
    children: [

      {
        name: '服务类型',
        path: '/general/serviceType'
      },
      {
        name: '保险公司',
        path: '/general/insurance'
      },
      {
        name: '支付方式',
        path: '/general/collection'
      },
      {
        name: '回访结果',
        path: '/general/returnvisit'
      },
    ]
  },
  {
    icon: require('./assets/img/menu/menu-icon12.png'),
    red_icon: require('./assets/img/menu/red-menu-icon12.png'),
    name: '个人中心',
    path: '/user',
    children: [
      {
        name: '个人信息',
        path: '/user/personal'
      },
      {
        name: '修改密码',
        path: '/user/password'
      },
      {
        name: '公司信息',
        path: '/user/company'
      }
    ]
  },
];
export default RouterList